"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Radio;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _theme = _interopRequireDefault(require("../../theme"));
var _focus = require("@react-aria/focus");
var _focus2 = require("../../styles/focus");
var _typographyHelper = require("../../utils/typographyHelper");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var StyledLabel = _styledComponents["default"].label.withConfig({
  displayName: "Radio__StyledLabel",
  componentId: "sc-fdf265-0"
})(["display:flex;align-items:center;background-color:#fff;border:1px solid ", ";border-radius:", ";padding:", ";font-family:", ";font-size:", ";font-weight:400;color:", ";cursor:pointer;", " ", " ", " ", " ", " ", ""], _theme["default"].grey60, _theme["default"].borderRadiusSmall, _theme["default"].space15, _theme["default"].nunito, (0, _typographyHelper.pxToRem)(16), _theme["default"].textColor, function (_ref) {
  var isChecked = _ref.isChecked;
  return isChecked && (0, _styledComponents.css)(["border-color:", ";background-color:", ";box-shadow:inset 0 0 0 1px ", ";font-weight:600;"], _theme["default"].indigo60, _theme["default"].indigo20, _theme["default"].indigo60);
}, function (_ref2) {
  var isDisabled = _ref2.isDisabled;
  return isDisabled && (0, _styledComponents.css)(["border-color:", ";background-color:", ";color:", ";cursor:not-allowed;pointer-events:none;"], _theme["default"].grey60, _theme["default"].grey20, _theme["default"].grey100);
}, function (_ref3) {
  var isDisabled = _ref3.isDisabled;
  return !isDisabled && (0, _styledComponents.css)(["&:hover{border-color:", ";box-shadow:inset 0 0 0 1px ", ";font-weight:600;}"], _theme["default"].indigo60, _theme["default"].indigo60);
}, function (_ref4) {
  var isDisabled = _ref4.isDisabled,
    isChecked = _ref4.isChecked;
  return isDisabled && isChecked && (0, _styledComponents.css)(["border-color:", ";background-color:", ";box-shadow:inset 0 0 0 1px ", ";"], _theme["default"].grey60, _theme["default"].grey20, _theme["default"].grey60);
}, function (_ref5) {
  var hasError = _ref5.hasError;
  return hasError && (0, _styledComponents.css)(["background-color:", ";border-color:", ";"], _theme["default"].errorLight, _theme["default"].errorDark);
}, function (_ref6) {
  var isFocusVisible = _ref6.isFocusVisible;
  return isFocusVisible && (0, _styledComponents.css)(["border:1px solid ", ";", " &:before{opacity:1;}"], _theme["default"].indigo60, _focus2.focusOutlineStyle);
});
var CustomRadioCheck = _styledComponents["default"].div.withConfig({
  displayName: "Radio__CustomRadioCheck",
  componentId: "sc-fdf265-1"
})(["margin-right:16px;display:flex;justify-content:center;align-items:center;box-sizing:border-box;width:16px;height:16px;min-width:16px;border:1px solid ", ";border-radius:50%;&:before{content:'';width:8px;height:8px;border-radius:50%;background-color:", ";opacity:0;}", " ", " ", " ", ""], _theme["default"].grey60, _theme["default"].indigo60, function (_ref7) {
  var isChecked = _ref7.isChecked;
  return isChecked && (0, _styledComponents.css)(["border:2px solid ", ";&:before{opacity:1;}"], _theme["default"].indigo60);
}, function (_ref8) {
  var hasError = _ref8.hasError;
  return hasError && (0, _styledComponents.css)(["background-color:#fff;"]);
}, function (_ref9) {
  var isDisabled = _ref9.isDisabled,
    isChecked = _ref9.isChecked;
  return isDisabled && isChecked && (0, _styledComponents.css)(["border:2px solid ", ";&:before{opacity:1;background-color:", ";}"], _theme["default"].grey60, _theme["default"].grey60);
}, function (_ref10) {
  var isFocusVisible = _ref10.isFocusVisible;
  return isFocusVisible && (0, _styledComponents.css)(["&:before{opacity:1;}"]);
});
var HiddenInput = _styledComponents["default"].input.withConfig({
  displayName: "Radio__HiddenInput",
  componentId: "sc-fdf265-2"
})(["margin:0;opacity:0;width:0;"]);
function Radio(_ref11) {
  var id = _ref11.id,
    value = _ref11.value,
    label = _ref11.label,
    name = _ref11.name,
    _ref11$isDisabled = _ref11.isDisabled,
    isDisabled = _ref11$isDisabled === void 0 ? false : _ref11$isDisabled,
    _ref11$isChecked = _ref11.isChecked,
    isChecked = _ref11$isChecked === void 0 ? false : _ref11$isChecked,
    _ref11$hasError = _ref11.hasError,
    hasError = _ref11$hasError === void 0 ? false : _ref11$hasError,
    onChange = _ref11.onChange,
    _ref11$required = _ref11.required,
    required = _ref11$required === void 0 ? false : _ref11$required;
  var _useFocusRing = (0, _focus.useFocusRing)(),
    isFocusVisible = _useFocusRing.isFocusVisible,
    focusProps = _useFocusRing.focusProps;
  return /*#__PURE__*/_react["default"].createElement(StyledLabel, {
    isDisabled: isDisabled,
    isChecked: isChecked,
    hasError: hasError,
    htmlFor: id,
    isFocusVisible: isFocusVisible
  }, /*#__PURE__*/_react["default"].createElement(CustomRadioCheck, {
    isDisabled: isDisabled,
    isChecked: isChecked,
    hasError: hasError,
    isFocusVisible: isFocusVisible
  }), label, /*#__PURE__*/_react["default"].createElement(HiddenInput, _extends({
    onChange: onChange,
    type: "radio",
    id: id,
    name: name,
    value: value,
    checked: isChecked,
    disabled: isDisabled,
    required: required
  }, focusProps)));
}
Radio.propTypes = {
  value: _propTypes["default"].string.isRequired,
  name: _propTypes["default"].string.isRequired,
  label: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func,
  id: _propTypes["default"].string,
  isDisabled: _propTypes["default"].bool,
  isChecked: _propTypes["default"].bool,
  hasError: _propTypes["default"].bool,
  required: _propTypes["default"].bool
};